import Card from 'components/core/card';

const ExchangeKeyCard = ({ children }: { children: any }) => {
  return <Card className='min-h-[20em] flex flex-col gap-3'>{children}</Card>;
};

export default ExchangeKeyCard;
